import Admin__TemplatesController from './templates.js'

Skylark.App.Controllers.register({
  Admin__TemplatesController
})

export default Admin__TemplatesController
